import {Actions} from './actions.js';

export class ActionsVap extends Actions {
	constructor(component_key) {
		super(component_key);
	}
	init() {
		super.init();
		this.add_event_listeners();
	}
	
	add_event_listeners() {
		jQuery('.js-suggestions_show_more').off('click.vap_actions').on('click.vap_actions', this.action_click_handler.bind(this));
	}
	action_click_handler() {
		const $root = this.$root.find('.js-actions_contact_suggestions');
		yalwa.basics.show($root.find('.js-contact_suggestion'));
		$root.find('.js-second').remove();
	}
}